import type { LucideIcon } from 'lucide-react'

export interface Reiter<K extends string> {
  key: K
  label: string
  icon?: LucideIcon
  /** Zählmarke neben der Beschriftung (Positionen, Dokumente …) */
  zahl?: number
}

/**
 * Die **Hauptreiter einer Detailseite** (AP-37 Nachtrag 1, N1-11): ohne Rahmen,
 * damit sie sich von den Karten abheben, mit einer Trennlinie in der
 * Firmenfarbe darunter; der aktive Reiter ist eine gefüllte Pille. Unter-Reiter
 * innerhalb eines Reiters bleiben bewusst schlicht (Unterstrich), damit die
 * Ebenen unterscheidbar bleiben.
 */
export function Reiterleiste<K extends string>({ reiter, aktiv, onWahl }: { reiter: Reiter<K>[]; aktiv: K; onWahl: (key: K) => void }) {
  return (
    <div role="tablist" className="flex flex-wrap items-center gap-1 border-b-2 border-primary pb-2">
      {reiter.map((r) => {
        const an = r.key === aktiv
        const Icon = r.icon
        return (
          <button
            key={r.key}
            type="button"
            role="tab"
            aria-selected={an}
            onClick={() => onWahl(r.key)}
            className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-sm transition-colors ${
              an ? 'bg-primary font-medium text-primary-foreground' : 'text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
          >
            {Icon && <Icon className="h-4 w-4" aria-hidden />}
            {r.label}
            {r.zahl !== undefined && (
              <span className={`rounded-full px-1.5 text-xs ${an ? 'bg-primary-foreground/90 text-primary' : 'bg-muted text-muted-foreground'}`}>{r.zahl}</span>
            )}
          </button>
        )
      })}
    </div>
  )
}
